// src/VerificacionEdad.js
import React from 'react';

function VerificacionEdad({ onAceptar }) {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6 text-center">
      <h1 className="text-3xl font-bold mb-6">Advertencia</h1>
      <p className="mb-6 max-w-xl">
        Este sitio contiene contenido para adultos. Solo puedes continuar si tienes más de 18 años.
      </p>
      <button
        onClick={onAceptar}
        className="bg-yellow-600 hover:bg-yellow-500 text-black font-semibold px-6 py-3 rounded shadow text-lg"
      >
        Sí, soy mayor de 18 años
      </button>
    </div>
  );
}

export default VerificacionEdad;
